module.exports = __webpack_public_path__ + "static_portal/img/spm.699a9c48.jpg";